//@ts-expect-error untyped
import PropertyGroupRecord from 'customer-data-objects/property/PropertyGroupRecord';
import I18n from 'I18n';
import get from 'transmute/get';
import identity from 'transmute/identity';
export const RECENTLY_USED_GROUP_NAME = 'hs_most_used_properties';
export const generateRecentlyUsedPropertyGroup = (recentlyUsedProperties, properties) => PropertyGroupRecord.fromJS({
  displayName: I18n.text('filterSidebar.mostUsedProperties'),
  displayOrder: -Infinity,
  hubspotDefined: true,
  name: RECENTLY_USED_GROUP_NAME,
  properties: recentlyUsedProperties.map(propertyName => get(propertyName, properties)).filter(Boolean).slice(0, 5)
},
// HACK: PropertyGroupRecord tries to convert properties to property records if its input is an array
// using the second argument to "fromJS" as a transformer. recentlyUsedProperties is an array which
// activates the transform, but properties are already PropertyRecords, so we pass the identity function
// to no-op the transform.
identity);